import React, { Component } from 'react';
import { connect } from 'react-redux'

import BusServiceInfo from '../../components/busServiceInfo';

import * as actions from './actions'
import { opdbGTM } from '../../utils/pulseUtils'

class BusServiceInfoContainer extends Component {
  
  componentDidMount() {
    this.props.fetchBusCategories();
    this.props.fetchMetaDetails();    
    opdbGTM.tabClicked('od_bus_service_info_tab_clicked');
  }
  
  render() {
    return(
      <BusServiceInfo {...this.props} />
    )
  }
}

const mapStateToProps = store => ({
  uploadNewPhotosWizardState: store.busServiceInfoReducer.uploadNewPhotosWizardState,
  busCategoriesList: store.busServiceInfoReducer.busCategoriesList,
  busServicesForCategories: store.busServiceInfoReducer.busServicesForCategories,
  selectedBusCategory: store.busServiceInfoReducer.selectedBusCategory,
  isSelectAllServices: store.busServiceInfoReducer.isSelectAllServices,
  isSelectedService: store.busServiceInfoReducer.isSelectedService,
  selectedBusServices: store.busServiceInfoReducer.selectedBusServices,
  uploadSelectedPhotos: store.busServiceInfoReducer.uploadSelectedPhotos,
  metaDetails: store.busServiceInfoReducer.metaDetails,
  successData: store.busServiceInfoReducer.successData,
})

const mapDispatchToProps = dispatch => ({
  fetchBusCategories: () => dispatch(actions.fetchBusCategories()),
  goToBusCategories: () => dispatch(actions.goToBusCategories()),
  fetchBusServices: (busCategory) => dispatch(actions.fetchBusServices(busCategory)),
  goToBusServices: () => dispatch(actions.goToBusServices()),
  goToPhotoSelection: () => dispatch(actions.goToPhotoSelection()),
  selectAllServicesHandler: (isSelectAllServices) => dispatch(actions.selectAllServicesHandler(isSelectAllServices)),
  selectIndividualServicesHandler: (isSelectedService, selectedRoute) => dispatch(actions.selectIndividualServicesHandler(isSelectedService, selectedRoute)),
  // setPhotosToUpload: (uploadSelectedPhotos) => dispatch(actions.setPhotosToUpload(uploadSelectedPhotos)),
  uploadSelectedPhotosHandler: (formDataArr, callback) => dispatch(actions.uploadSelectedPhotosHandler(formDataArr, callback)),
  fetchMetaDetails: () => dispatch(actions.fetchMetaDetails()),
  resetStore: () => dispatch(actions.resetStore())
})

export default connect(mapStateToProps, mapDispatchToProps)(BusServiceInfoContainer)
